import React from 'react';
const Spinner = () => {
    return (
        <svg className="spinner send-icon" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20" fill="none" strokeWidth="4"></circle>
        </svg>
    )
};

export default Spinner;
